import api from './api'
import {
  Rule,
  RulesListResponse,
  RuleCategory,
  RequestType,
  WorkCenterType,
  RuleValues,
  RuleConditions,
  ApiResponse,
} from '../types'

export interface RuleFilters {
  category?: RuleCategory
  requestType?: RequestType
  workCenter?: WorkCenterType
  isActive?: boolean
  search?: string
}

export interface CreateRuleData {
  code: string
  name: string
  description?: string
  category: RuleCategory
  requestType?: RequestType
  workCenter?: WorkCenterType
  values: RuleValues
  conditions?: RuleConditions
  errorMessage?: string
  priority?: number
  sortOrder?: number
  isActive?: boolean
}

export interface UpdateRuleData {
  code?: string
  name?: string
  description?: string | null
  category?: RuleCategory
  requestType?: RequestType | null
  workCenter?: WorkCenterType | null
  values?: RuleValues
  conditions?: RuleConditions | null
  errorMessage?: string | null
  priority?: number
  sortOrder?: number
  isActive?: boolean
}

export const ruleService = {
  async getAll(filters?: RuleFilters): Promise<RulesListResponse> {
    const params = new URLSearchParams()
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          params.append(key, String(value))
        }
      })
    }
    const response = await api.get<ApiResponse<RulesListResponse>>(
      `/configuration/rules?${params.toString()}`
    )
    return response.data.data
  },

  async getAllGrouped(): Promise<RulesListResponse> {
    const response = await api.get<ApiResponse<RulesListResponse>>(
      '/configuration/rules/grouped'
    )
    return response.data.data
  },

  async getById(id: string): Promise<Rule> {
    const response = await api.get<ApiResponse<Rule>>(`/configuration/rules/${id}`)
    return response.data.data
  },

  async getByCode(code: string): Promise<Rule> {
    const response = await api.get<ApiResponse<Rule>>(`/configuration/rules/code/${code}`)
    return response.data.data
  },

  async create(data: CreateRuleData): Promise<Rule> {
    const response = await api.post<ApiResponse<Rule>>('/configuration/rules', data)
    return response.data.data
  },

  async update(id: string, data: UpdateRuleData): Promise<Rule> {
    const response = await api.put<ApiResponse<Rule>>(`/configuration/rules/${id}`, data)
    return response.data.data
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/configuration/rules/${id}`)
  },

  async toggleActive(id: string): Promise<Rule> {
    const response = await api.patch<ApiResponse<Rule>>(`/configuration/rules/${id}/toggle`)
    return response.data.data
  },

  async seedDefaults(): Promise<{ created: number }> {
    const response = await api.post<ApiResponse<{ created: number }>>('/configuration/rules/seed')
    return response.data.data
  },
}
